import _createForOfIteratorHelper from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _objectSpread from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
export default {
  name: 'deviceItem_page',
  props: {
    current: {
      type: Object,
      default: {}
    }
  },
  data: function data() {
    return {
      pageConfig: {
        editPageName: '参数',
        addFunName: 'deviceItemAdd',
        modifyFunName: 'deviceItemModify',
        delFunName: 'deviceItemDel',
        queryFunName: 'deviceItemQuery',
        detailFunName: 'deviceItemDetail',
        dicTreeFunName: 'dictionaryCache'
      },
      searchForm: {
        page: 1,
        limit: 10,
        searchKey: null,
        deviceId: this.current.id,
        sortField: '^sort',
        type: ''
      },
      formData: {
        deviceId: this.current.id,
        remark: null,
        type: null,
        unit: null,
        valuePath: null,
        valueTimePath: null,
        valueType: 'Integer',
        valueMultiply: 1,
        valueOffset: 0,
        interactiveProtocol: 'Modbus_RTU',
        endianMode: 'LITTLE_ENDIAN',
        typeCategory: 'Monitor',
        typeGroup: 'default_group'
      },
      rules: {
        valueType: [{
          required: true,
          message: '请选择值类型',
          trigger: 'blur'
        }],
        valuePath: [{
          required: true,
          message: '请输入值路径',
          trigger: 'blur'
        }],
        typeName: [{
          required: true,
          message: '请输入检测项目名称',
          trigger: 'blur'
        }],
        typeCode: [{
          required: true,
          message: '请输入检测项目代码',
          trigger: 'blur'
        }],
        unit: [{
          required: true,
          message: '请输入计量单位',
          trigger: 'blur'
        }],
        typeCategory: [{
          required: true,
          message: '请选择项目类别',
          trigger: 'blur'
        }],
        typeGroup: [{
          required: true,
          message: '请输入检测项目分组',
          trigger: 'blur'
        }],
        interactiveProtocol: [{
          required: true,
          message: '请选择交互协议',
          trigger: 'blur'
        }]
      },
      queryLoading: true,
      tableData: [],
      totalCount: 0,
      editDialogShow: false,
      editDialogTitle: '',
      formLabelWidth: '120px',
      emptyFormData: {},
      valueEnums: [],
      typeCategory: {
        Monitor: '检测参数',
        Status: '状态参数'
      }
    };
  },
  watch: {
    'formData.interactiveProtocol': {
      handler: function handler(to) {
        if (to == 'JSON') {
          this.$set(this.formData, 'valueType', 'String');
        }
      },
      deep: true
    }
  },
  mounted: function mounted() {
    // console.log('deviceItem_page this.current',this.current)
    // this.deviceId = this.current.id
    this.emptyFormData = JSON.parse(JSON.stringify(this.formData));
    this.query();
  },
  methods: {
    back: function back() {
      this.$emit('child-go-device');
    },
    initFormData: function initFormData(data) {
      var paramData = JSON.parse(JSON.stringify(data));
      // 值枚举
      this.valueEnums = [];
      for (var key in paramData.valueEnums) {
        this.valueEnums.push({
          label: key,
          value: paramData.valueEnums[key]
        });
      }
      this.formData = paramData;
      if (!this.formData.valueType) {
        this.formData.valueType = 'Integer';
      }
      if (typeof this.$refs['formDataVerify'] !== 'undefined') {
        this.$refs['formDataVerify'].clearValidate();
      }
    },
    saveFormDataProcess: function saveFormDataProcess(formData) {
      var saveFormData = JSON.parse(JSON.stringify(formData));
      return saveFormData;
    },
    valueEnumsAdd: function valueEnumsAdd() {
      this.valueEnums.push({
        label: '',
        value: ''
      });
    },
    valueEnumsDel: function valueEnumsDel(index) {
      this.valueEnums.splice(index, 1);
    },
    add: function add() {
      this.editDialogTitle = this.pageConfig.editPageName + '新增';
      this.editDialogShow = true;
      this.valueEnums = [];
      this.formData.upperCode = this.searchForm.upperCode;
    },
    edit: function edit(id) {
      var _this = this;
      this.$api[this.pageConfig.detailFunName](id).then(function (res) {
        _this.initFormData(_objectSpread(_objectSpread({}, res.data), {}, {
          valueEnums: res.data.valueEnums ? JSON.parse(res.data.valueEnums) : {}
        }));
        _this.editDialogTitle = _this.pageConfig.editPageName + '维护';
        _this.editDialogShow = true;
      });
    },
    del: function del(id) {
      var _this2 = this;
      this.$confirm('确定要删除吗').then(function () {
        _this2.$api[_this2.pageConfig.delFunName](id).then(function (res) {
          if (res.data) {
            _this2.$message.success('删除成功');
            _this2.query();
          } else {
            _this2.$message.error('删除失败');
          }
        });
      });
    } // 历史记录
    ,
    history: function history(course) {
      // console.log('参数跳转历史记录')
      this.$emit('child-go', course, 'history', this.current);
    },
    query: function query() {
      var _this3 = this;
      this.queryLoading = true;
      this.searchForm.deviceId = this.current.id;
      this.$api[this.pageConfig.queryFunName](this.searchForm).then(function (res) {
        _this3.tableData = res.data || [];
        _this3.totalCount = res.count;
        _this3.queryLoading = false;
      });
    },
    submitFormData: function submitFormData() {
      var _this4 = this;
      this.$refs['formDataVerify'].validate(function (valid) {
        if (valid) {
          _this4.formData.deviceId = _this4.current.id;
          // 值枚举
          var valueEnums = {};
          var _iterator = _createForOfIteratorHelper(_this4.valueEnums),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var item = _step.value;
              if (!item.label || !item.value) {
                _this4.$message.info('值枚举不能为空！');
                return;
              }
              if (item.label && item.value) {
                valueEnums[item.label] = item.value;
              }
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
          if (_this4.formData.id) {
            _this4.$api[_this4.pageConfig.modifyFunName](_this4.saveFormDataProcess(_objectSpread(_objectSpread({}, _this4.formData), {}, {
              valueEnums: JSON.stringify(valueEnums)
            }))).then(function (res) {
              if (res.data) {
                _this4.$message.success('编辑成功');
                _this4.initFormData(_this4.emptyFormData);
                _this4.editDialogShow = false;
                _this4.query();
              } else {
                _this4.$message.error('编辑失败');
              }
            });
          } else {
            _this4.$api[_this4.pageConfig.addFunName](_this4.saveFormDataProcess(_objectSpread(_objectSpread({}, _this4.formData), {}, {
              valueEnums: JSON.stringify(valueEnums)
            }))).then(function (res) {
              if (res.data) {
                _this4.$message.success('新增成功');
                _this4.initFormData(_this4.emptyFormData);
                _this4.editDialogShow = false;
                _this4.query();
              } else {
                _this4.$message.error('新增失败');
              }
            });
          }
        }
      });
    },
    closeEditDialogShow: function closeEditDialogShow() {
      this.editDialogTitle = '';
      this.editDialogShow = false;
      this.initFormData(this.emptyFormData);
    },
    search: function search() {
      this.searchForm.page = 1;
      this.query();
    },
    pageChange: function pageChange(page) {
      this.searchForm.page = page;
      this.query();
    },
    sizeChange: function sizeChange(limit) {
      this.searchForm.page = 1;
      this.searchForm.limit = limit;
      this.query();
    },
    sortChange: function sortChange(column) {
      this.searchForm.page = 1;
      this.searchForm.sortField = column.order === 'ascending' ? '^' + this.camelToUnderline(column.prop) : column.order === 'descending' ? this.camelToUnderline(column.prop) : '^sort';
      this.query();
    }
  }
};